import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[locale]/search/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/src/components/Card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/app/src/search/Component.tsx");
